import { Callout } from "components/ui/callout";
import * as React from "react";
import { useNewLayout } from "store/selectors/hooks";

interface ActionBarChildrenParams {
    close: () => void;
}

interface IActionBarComponentProps {
    label: string;
    value: string;
    children?: ((params: ActionBarChildrenParams) => React.ReactNode) | React.ReactNode;
    className?: string;
}

export const ActionBarComponent: React.FunctionComponent<IActionBarComponentProps> = (
    props: IActionBarComponentProps,
) => {
    const { label, value, children, className } = props;
    const [isCalloutOpen, setIsCalloutOpen] = React.useState(false);
    const openCallout = React.useCallback(() => {
        setIsCalloutOpen(true);
    }, [setIsCalloutOpen]);
    const newLayout = useNewLayout();

    const renderButton = React.useCallback(() => {
        if (newLayout) {
            return (
                <>
                    {/* Compact toolbar button for small screens (below lg) */}
                    <div className={`lg:hidden`} onClick={openCallout}>
                        <button
                            type="button"
                            className={`rounded-full bg-gray-100 px-3 py-1 flex items-center gap-2 shadow border border-gray-200 text-sm font-medium text-gray-800 hover:bg-gray-200 transition`}
                            aria-label={label}>
                            {/* Optionally add an icon here */}
                            <span className="font-semibold">{value}</span>
                        </button>
                    </div>
                    {/* Legacy blue box for large screens (lg and up) */}
                    <div
                        className={`action-bar-component ${
                            className ?? ""
                        } max-lg:hidden`}
                        onClick={openCallout}>
                        <div className="action-bar-label">{label}</div>
                        <div className="action-bar-value">
                            <a href="#" onClick={openCallout}>
                                {value}
                            </a>
                        </div>
                    </div>
                </>
            );
        }
        // Fallback to existing style if newLayout is false
        return (
            <div
                className={`action-bar-component ${className ?? ""}`}
                onClick={openCallout}>
                <div className="action-bar-label">{label}</div>
                <div className="action-bar-value">
                    <a href="#" onClick={openCallout}>
                        {value}
                    </a>
                </div>
            </div>
        );
    }, [label, value, openCallout, className, newLayout]);

    const params = React.useMemo(() => {
        return {
            close: () => {
                setIsCalloutOpen(false);
            },
        };
    }, [setIsCalloutOpen]);

    return (
        <Callout
            renderButton={renderButton}
            onOpen={openCallout}
            forceClose={!isCalloutOpen}>
            <div className="w-80">
                {typeof children === "function" ? children(params) : children}
            </div>
        </Callout>
    );
};
